module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-nissan.4575589e.jpg";